import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ConversationsLayout, validateConversationsSearch } from '@/features/conversations/ConversationsLayout';

export const Route = createFileRoute('/app/conversations')({
  component: ConversationsRoute,
  staticData: { title: 'Conversations' },
  validateSearch: validateConversationsSearch,
});

function ConversationsRoute() {
  const search = Route.useSearch();
  return (
    <ConversationsLayout search={search}>
      <Outlet />
    </ConversationsLayout>
  );
}
